const getShopImages = () => document.getElementsByClassName("enlargeable-photo")
document.addEventListener('DOMContentLoaded', () => {
  const lightbox  = document.getElementById("photo-lightbox");

  if (lightbox) {
    const lightboxImage = document.getElementById("photo-lightbox-image");
    const nextButton = document.getElementById("photo-lightbox-next-button");
    const backButton = document.getElementById("photo-lightbox-back-button");
    const shopImages = getShopImages();
    Array.from(shopImages).forEach(
      (el) => {
        const params = enlargeParamsFromElement(el);
        el.addEventListener('click', (el)=> enlargePhoto({...params, max: shopImages.length}))
      }
    )

    nextButton.addEventListener("click", changeImage('next'))
    backButton.addEventListener("click", changeImage('back'))
    setupTouchSwipe(lightboxImage);

    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('hidden') && e.key === 'ArrowLeft') changeImage('back')();
      if (!lightbox.classList.contains('hidden') && e.key === 'ArrowRight') changeImage('next')();
    });
  }
})

function setupTouchSwipe(imageElement){
  const state = { };
  imageElement.addEventListener('touchstart', initializeTouch(state), false);
  imageElement.addEventListener('touchend', completeTouch(state), false);
}

function initializeTouch(state){
  return function(e){
    state['start'] = e.touches[0].clientX;
  }
}

function completeTouch(state){
  return function(e){
    state['end'] = e.changedTouches[0].clientX;
    if(state['start'] >= state['end']){
      changeImage('next')()
    }else{
      changeImage('back')()
    }
  }
}

function changeImage(direction){
  return () => {
    const position = parseInt(document.getElementById("photo-lightbox-image").getAttribute("data-position"));
    const images = document.getElementsByClassName("enlargeable-photo")
    let nextPosition = 0;
    switch(direction){
    case 'next':
      nextPosition = enlargeNextImage({position, images});
      break;
    case 'back':
      nextPosition = enlargePreviousImage({position, images});
      break;
    }
    switchPhoto({...enlargeParamsFromElement(images[nextPosition]), max: images.length})
  }
}

function enlargeParamsFromElement(el){
  return {
    description: el.getAttribute("data-image-description"),
    loc: el.getAttribute("data-large-src"),
    position: parseInt(el.getAttribute("data-position")),
  }
}

function enlargePreviousImage({ position, images }){
  let nextPosition = position - 1;
  if (nextPosition < 0) nextPosition = images.length - 1;
  return nextPosition;
}

function enlargeNextImage({ position, images }){
  let nextPosition = position + 1;
  if (nextPosition == images.length) nextPosition = 0;
  return nextPosition;
}

function switchPhoto({ loc, position, max, description }){
  document.getElementById("photo-lightbox-image").setAttribute("src", loc);
  document.getElementById("photo-lightbox-image").setAttribute("data-position", position);

  document.getElementById("photo-lightbox-description").innerHTML=description;
  document.getElementById("photo-lightbox-position").innerHTML=(position+1);
  document.getElementById("photo-lightbox-maximum").innerHTML=(max);
}

function enlargePhoto({ loc, position, max, description }){
  window.present('photo-lightbox');
  document.getElementById("photo-lightbox-image").setAttribute("src", loc);
  document.getElementById("photo-lightbox-image").setAttribute("data-position", position);

  document.getElementById("photo-lightbox-description").innerHTML=description;
  document.getElementById("photo-lightbox-position").innerHTML=(position+1);
  document.getElementById("photo-lightbox-maximum").innerHTML=(max);
}

function hideLightbox() {
  window.dismiss('photo-lightbox');
}
